module.exports = __webpack_public_path__ + "static/media/veg-cat.45ef1188.PNG";